<title>{{ ndcCommercialFaqPage.htmlTitle }}</title>
<app-banner [banner]="ndcCommercialFaqPage.banner"></app-banner>
<div class="container innerContent faqpages">
  <a [href]="BackLinkURL"><i [ngClass]="BackLinkIcon"></i>{{ BackLinkTitle }}</a>
  <app-border-section [isInnerBorder]="true" [sections]="ndcCommercialFaqPage.sections"></app-border-section>
</div>
